import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { AIDisclosureState } from '../type/ai-disclosure.type';
import { AIDisclosureStep } from '../type/ai-disclosure.enum';

export const AIDisclosureModel = Symbol('AIDisclosureModel');

export type AIDisclosureModel = AbstractModel<AIDisclosureState>

@injectable()
export class AIDisclosureModelImpl extends AbstractModel<AIDisclosureState> implements AIDisclosureModel {
    protected _modelData: AIDisclosureState = {
        input: '',
        currentStep: AIDisclosureStep.DEFAULT,
    };
}
